const actions = {
    GET_DAILY_STATISTICS: "statistics/GET_DAILY_STATISTICS",
    SET_DAILY_STATISTICS: "statistics/SET_DAILY_STATISTICS",

    GET_PREV_STATISTICS: 'statistics/GET_PREV_STATISTICS',
    SET_PREV_STATISTICS: 'statistics/SET_PREV_STATISTICS',

    GET_FUEL_REPORT_BY_VEHICLE: "statistics/GET_FUEL_REPORT_BY_VEHICLE",
    SET_FUEL_REPORT_BY_VEHICLE: "statistics/SET_FUEL_REPORT_BY_VEHICLE",

    GET_FUEL_REPORT_BY_DRIVER: "statistics/GET_FUEL_REPORT_BY_DRIVER",
    SET_FUEL_REPORT_BY_DRIVER: "statistics/SET_FUEL_REPORT_BY_DRIVER",
};

export default actions